import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import logo from "assets/img/rightel_logo.jpg";
import Learning from "../Main/Sections/Learning";


import styles from "assets/jss/material-kit-react/views/landing.js";

const useStyles = makeStyles(styles);

export default function MPMMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/MyRightel.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={logo} alt="..." className={imageClasses} />
                                    </div>
                                </div>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.name +" "+ classes.center}>
                                    <h3 className={classes.title}>رایتلی عزیز!</h3>
                                </div>
                                <div className={classes.description}>
                                    <p className={classes.center}>
                                        کد تخفیف زیر را در موقع خرید وارد نمائید تا از <strong>25 درصد</strong> تخفیف دوره‌های آموزشی گروه فناوری اطلاعات و ارتباطات شریف برخوردار شوید.
                                        <h3><strong>کد تخفیف: Righteliha1400</strong></h3>

                                    <br />
                                        <Button variant="outlined" color="primary" target='_blank' href="/Courses" disableElevation>
                                            مشاهده لیست دوره‌ها                                    </Button>
                                    </p>
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                            <div className={classes.center}>
                            <Learning />
</div>09307969475
                            </GridItem>


                        </GridContainer>


                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
